import React from 'react';
import Dialog from '@mui/material/Dialog';
import CodeLogin from '@/components/login/CodeLogin';
import WechatLogin from '@/components/login/WechatLogin';
import setAlertValue from '@/components/alert';
import BackgroundImage from '@/assets/login/background.png';

const LoginModal = (props: {
  isOpen: boolean;
  searchParams?: URLSearchParams;
}) => {
  const { isOpen, searchParams } = props;
  const [isCodeLogin, setIsCodeLogin] = React.useState(false);

  React.useEffect(() => {
    return () => setAlertValue.clearAlert();
  }, []);

  return (
    <Dialog
      open={isOpen}
      maxWidth="xs"
      PaperProps={{ className: '!bg-transparent !shadow-none' }}
    >
      <div
        className="flex flex-col px-6 py-10 rounded-2.5xl max-w-[400px] min-w-[240px] bg-no-repeat bg-contain bg-top bg-white tablet:max-w-auto tablet:w-[440px]"
        style={{ backgroundImage: `url(${BackgroundImage.src})` }}
      >
        <div className={isCodeLogin ? 'block' : 'hidden'}>
          <CodeLogin
            headerTitle="验证码登录/注册"
            subTitle="谈职，从一份好的简历开始"
            setIsCodeLogin={setIsCodeLogin}
            headerTitleClassName="text-2xl"
            textFieldSx={{
              backgroundColor: '#fff',
              boxShadow: '0px 4px 14px 0px #0000001f',
            }}
            defaultSearchParams={searchParams}
          />
        </div>
        {!isCodeLogin && (
          <WechatLogin
            setIsCodeLogin={setIsCodeLogin}
            subTitle="谈职，从一份好的简历开始"
            headerTitleClassName="text-2xl"
            defaultSearchParams={searchParams}
          />
        )}
      </div>
    </Dialog>
  );
};

export default LoginModal;
